// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__u3WIu","title":"Info_title__2OLxG","selects":"Info_selects__2LGSk","requiredAsterisk":"Info_requiredAsterisk__2J9wM"};